import React, { useLayoutEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/mst';
import DrawerSurface from '../../shared/Panel/DrawerSurface';
import DetailsPanelContent from './DetailsPanelContent';
import { PanelType } from './PanelType';

// Re-exported so existing `import { PanelType } from '.../DetailsPanel'` sites
// keep working; the enum now lives in its own leaf module (./PanelType).
export { PanelType };

interface Props {
  panelOpen: boolean;
}

const DetailsPanel: React.FC<Props> = ({ panelOpen }) => {
  const { ui } = useStore();
  const surfaceRef = useRef<HTMLDivElement>(null);

  // Mount-only: deep links land keyboard focus in the details, not on the map.
  useLayoutEffect(() => {
    if (panelOpen) {
      surfaceRef.current?.focus();
    }
  }, []);

  return (
    <DrawerSurface ref={surfaceRef} tabIndex={-1} $inert={ui.disablePointerEvents}>
      {panelOpen && <DetailsPanelContent panelOpen={panelOpen} />}
    </DrawerSurface>
  );
};

export default observer(DetailsPanel);
